import { HttpFailedToFetchException } from "../model/httpException";
import { ProjectShort } from "../model/projectShort";
import { getAuthHeaders } from "../utils/authHeaders";
import { logException } from "../utils/logUtils";
import { fetchWithRetry } from "../utils/retry.util";

export type SortBy = "last_access" | "created_at" | "project_name";
export type SortOrder = "asc" | "desc";

export interface ProjectsQueryParams {
  sortBy?: SortBy;
  sortOrder?: SortOrder;
}

export class ProjectsApi {
  private static readonly BASE_URL = import.meta.env.VITE_API_URL;

  static async getProjectsForUser(
    params?: ProjectsQueryParams
  ): Promise<ProjectShort[]> {
    const headers = await getAuthHeaders({});

    const queryParams = new URLSearchParams();
    queryParams.set("include_without_names", "false");
    if (params?.sortBy) {
      queryParams.set("sort_by", params.sortBy);
    }
    if (params?.sortOrder) {
      queryParams.set("sort_order", params.sortOrder);
    }

    const response = await fetchWithRetry(
      `${this.BASE_URL}/projects?${queryParams.toString()}`,
      {
        method: "GET",
        headers,
      }
    );

    if (!response.ok) {
      const errorText = await response.text();
      logException("Projects API error (/projects):", {
        status: response.status,
        statusText: response.statusText,
        body: errorText,
      });
      throw new HttpFailedToFetchException();
    }

    const data = await response.json();
    return data.projects;
  }
}
